import { Box, Heading, Text, Divider, Skeleton, Flex } from '@chakra-ui/react';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import React from 'react';

import { utils as commonUtils } from '@finley-technologies/common';

import {
  SettingsBreadcrumb,
  SettingsFacilitiesBreadcrumb,
} from './SettingsBreadcrumbs';
import { colors } from 'packages/common-frontend/colors';
import { Breadcrumbs } from 'packages/common-frontend/components/Breadcrumbs';
import { useGetCreditFacilityQuery } from 'packages/credit-facility/requests/requests.gql.generated';

export const SettingsFacilityPortfolioCovenantsTemplate: React.FC<{
  creditFacilityId: string;
  children: React.ReactNode;
}> = withLDConsumer()(({ creditFacilityId, children }) => {
  const {
    data: creditFacilityData,
    loading: isCreditFacilityLoading,
  } = useGetCreditFacilityQuery({ variables: { creditFacilityId } });

  if (!creditFacilityData || isCreditFacilityLoading) {
    return (
      <Skeleton
        h="600px"
        data-testid="settings-facility-portfolio-covenants-template-loading"
      />
    );
  }

  const creditFacilityName = commonUtils.creditFacilitySlugToName(
    creditFacilityData.creditFacility.slug,
  );

  const breadcrumbs = [
    SettingsBreadcrumb,
    SettingsFacilitiesBreadcrumb,
    {
      label: creditFacilityName,
    },
    {
      label: 'Portfolio Covenants',
    },
  ];

  return (
    <Box p="40px">
      <Breadcrumbs breadcrumbs={breadcrumbs} />
      <Box mt="16px">
        <Heading as="h1" mt="16px" mb="16px" fontSize="36px" fontWeight={600}>
          Portfolio Covenants
        </Heading>
        <Flex>
          <Text fontSize="16px" mb="16px" color={colors.black[70]}>
            Manage portfolio covenants for&nbsp;
          </Text>
          <Text fontSize="16px" mb="16px" fontWeight={500}>
            {`${creditFacilityName}.`}
          </Text>
        </Flex>
        <Divider />
      </Box>

      <Box mt="32px">{children}</Box>
    </Box>
  );
});
